export const FETCH_CLIENT_REQUEST = 'FETCH_CLIENT_REQUEST';
export const FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS';
export const FETCH_CLIENT_FAILURE = 'FETCH_CLIENT_FAILURE';

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE';

export const CLEAR_AUTOSAVE = 'CLEAR_AUTOSAVE';

export const GET_BOOKING_HISTORY_REQUEST = 'GET_BOOKING_HISTORY_REQUEST';
export const GET_BOOKING_HISTORY_SUCCESS = 'GET_BOOKING_HISTORY_SUCCESS';
export const GET_BOOKING_HISTORY_FAILURE = 'GET_BOOKING_HISTORY_FAILURE';

export const GET_SCHEDULED_BOOKING_REQUEST = 'GET_SCHEDULED_BOOKING_REQUEST';
export const GET_SCHEDULED_BOOKING_SUCCESS = 'GET_SCHEDULED_BOOKING_SUCCESS';
export const GET_SCHEDULED_BOOKING_FAILURE = 'GET_SCHEDULED_BOOKING_FAILURE';

export const GET_NO_SHOWS_REQUEST = 'GET_NO_SHOWS_REQUEST';
export const GET_NO_SHOWS_SUCCESS = 'GET_NO_SHOWS_SUCCESS';
export const GET_NO_SHOWS_FAILURE = 'GET_NO_SHOWS_FAILURE';

export const REMOVE_EDIT_CLIENT = 'REMOVE_EDIT_CLIENT';
